import React from "react";
import { ArrowRight, Shield, Zap, Globe, Smartphone, Landmark } from "lucide-react";
import { Link } from "react-router-dom";

const FeaturesSection = () => {
  const features = [
    {
      title: "CONNETTIVITÀ",
      subtitle: "Office Plus & Maxi",
      description: "Fibra Ottica fino a 2.5 Gbps per una velocità senza compromessi.",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800",
      highlight: "VELOCE",
      link: "/connettivita",
      icon: <Zap className="w-8 h-8 text-orange-500" />
    },
    {
      title: "ICT & SECURITY",
      subtitle: "Cyber Security & Cloud",
      description: "Proteggi i tuoi dati con soluzioni certificate e monitoraggio H24.",
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800",
      highlight: "SICURO",
      link: "/ict",
      icon: <Shield className="w-8 h-8 text-orange-500" />
    },
    {
      title: "MOBILE & FISSO",
      subtitle: "Smart Working",
      description: "Soluzioni voce e dati illimitati con 5G WindTre Business.",
      image: "https://images.unsplash.com/photo-1520923642038-b4259ace9439?auto=format&fit=crop&q=80&w=800",
      highlight: "MOBILE",
      link: "/fisso-mobile",
      icon: <Smartphone className="w-8 h-8 text-orange-500" />
    },
    {
      title: "PUBBLICA PA",
      subtitle: "Convenzioni CONSIP",
      description: "Partner tecnologico accreditato per la digitalizzazione degli uffici pubblici.",
      image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
      highlight: "CERTIFICATO",
      link: "/pubblica",
      icon: <Landmark className="w-8 h-8 text-orange-500" />
    }
  ];

  return (
    <section className="bg-white py-32 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tighter uppercase leading-tight">
              L'Ecosistema <span className="text-orange-500">Business</span>
            </h2>
            <p className="text-xl text-gray-600 font-medium">
              Soluzioni integrate per accelerare la crescita digitale della tua impresa.
            </p>
          </div>
          <Link to="/preventivo" className="group flex items-center text-orange-500 font-black text-lg uppercase tracking-widest">
            Tutti i Servizi <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Link to={feature.link} key={index} className="group relative bg-gray-50 rounded-[3rem] overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-500">
              <div className="aspect-[4/5] overflow-hidden">Refactor FeaturesSection componentfeat: modernize FeaturesSection layout and style with SME Book 2026 core areas
                <img 
                  src={feature.image} 
                  alt={feature.title} 
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                />
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent p-10 flex flex-col justify-end text-white">
                <div className="bg-orange-500 text-[10px] font-black tracking-widest px-3 py-1 rounded-full w-fit mb-4 uppercase">
                  {feature.highlight}
                </div>
                <div className="mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-sm font-bold tracking-widest text-orange-400 mb-2 uppercase">{feature.title}</h3>
                <h4 className="text-2xl font-black mb-4 uppercase leading-tight">{feature.subtitle}</h4>
                <p className="text-sm text-gray-300 line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {feature.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
